import './BdaApplicationDetail.scss';
import 'react-js-cron/dist/styles.css'

import { Helmet } from "react-helmet";
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Alert, Badge, Card, Col, Container, Row, ListGroup, ListGroupItem, Modal, Button, Form, Breadcrumb, Table, Offcanvas } from 'react-bootstrap';
import { useParams } from 'react-router';
import { Applications } from '../../api/Applications';
import AppLoader from '../../components/common/AppLoader';
import DesignerComponent from '../../components/designer/Designer';
import UserItem from '../../components/common/UserItem';
import { useToasts } from '../../contexts/toasts';
import { fixProcedure, formatDate, getConnectionDetails, createQueryDetails, getStatusBadge, getExecutionTime, renderTopicLink } from '../../utils';
import classNames from 'classnames';
import IconButton from '../../components/common/IconButton';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useNavigate } from 'react-router';
import { K8sClient } from '../../api/K8sClient';
import FileSaver from 'file-saver';
import { Link } from 'react-router-dom';
import { VizClient } from '../../api/VizClient';
import { Models } from '../../api/Models';
import EvaluationRecap from '../../components/generics/EvaluationRecap';
import { GraphV2, getIdFromUUID, translateGraph } from '../../utils/DesignerUtils';
import { Schedules } from '../../api/Schedules';
import { TailSpin } from 'react-loader-spinner';
import { cloneDeep, set } from 'lodash';
import { Cron } from 'react-js-cron';
import { isAfter, isBefore } from 'date-fns';
import { Collapse, Select, Tooltip } from 'antd';
import { EventEmitter } from '../../utils/EventEmitter';
import { ApplicationVersion, BdaApplication } from '../../models/BdaApplication';
import { BdaDataset } from '../../models/BdaDataset';
import { BdaService } from '../../models/BdaService';
import { BdaModel } from '../../models/BdaModel';
import { Execution, Schedule } from '../../models/Workflow';
import { AppNotification } from '../../models/Notification';
import { AssetFile, ExecutionStatus, ExportOptions, Option } from '../../models/generics';
import AssetFileItem from '../../components/list-items/AssetFileItem';
import { ReactFlowProvider, useReactFlow } from 'reactflow';


const groupsIcons = {
  workflow: solid('project-diagram'),
  datasets: solid('database'),
  models: solid('graduation-cap'),
  schedules: solid('stopwatch'),
}

function BdaApplicationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialGraph, setInitialGraph] = useState<GraphV2>();
  const { setNodes, setEdges } = useReactFlow();

  const { showToast } = useToasts();
  const { showLoader, hideLoader } = useFullScreenLoader();

  const [application, setApplication] = useState<BdaApplication>();
  // const [currentGraph, setCurrentGraph] = useState(null);

  // TODO improve logs and preview
  const [logs, setLogs] = useState<any>();
  const [preview, setPreview] = useState<any[]>();
  const [previewDataset, setPreviewDataset] = useState<BdaDataset>();
  const [evaluationDataset, setEvaluationDataset] = useState<BdaDataset>();
  const [logsError, setLogsError] = useState(false);
  const [error, setError] = useState(false);
  const [showElementDetail, setShowElementDetail] = useState(false);
  const [service, setService] = useState<BdaService>();
  const [dataset, setDataset] = useState<BdaDataset>();
  const [model, setModel] = useState<BdaModel>();
  const [runs, setRuns] = useState<Execution[]>();
  const [assetFiles, setAssetFiles] = useState<AssetFile[]>();
  const [selectedRun, setSelectedRun] = useState<Execution>();
  const [exportOptions, setExportOptions] = useState(new ExportOptions(id));
  const [executionsOptions, setExecutionsOptions] = useState<Option[]>([]);
  const [selectedExecution, setSelectedExecution] = useState<string | undefined>();
  const [exportMode, setExportMode] = useState('cluster');
  const [showNotifications, setShowNotifications] = useState(false);
  const [showVersions, setShowVersions] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showDataModal, setShowDataModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showDeleteScheduleModal, setShowDeleteScheduleModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [newSchedule, setNewSchedule] = useState(new Schedule());
  const [schedule, setSchedule] = useState<Schedule>();
  const [customCron, setCustomCron] = useState<string>();
  const [cronError, setCronError] = useState<string>();

  useEffect(() => {
    setApplication(undefined);
    getApplication();
    // eslint-disable-next-line
  }, [id]);

  const serviceIsExposable = useMemo(() => {
    const propertyKeys = service?.properties.map(prop => prop.key);
    return propertyKeys?.includes(window.__env.SERVICE_PORTS_TO_EXPOSE_KEY || 'portsToExpose');
  }, [service]);

  // TODO improve statusmessage type
  const onStatusNotification = useCallback((statusMessage: any) => {
    if (!statusMessage.serviceId) {
      setApplication(app => ({
        ...app!,
        status: statusMessage.bda.status,
      }));
      // if (currentApplication.status == "STARTED" || currentApplication.status == "RUNNING" || currentApplication.status == "STARTING") buttonsDisabled = true;
      // if (currentApplication.status != "STARTED" && currentApplication.status != "RUNNING") buttonsDisabled = false;
      if (statusMessage.bda.status === "ERROR" || statusMessage.bda.status === "COMPLETED") getApplication();
    }
    else {
      const serviceRef = application!.workflows[0].services
        .find(el => el.id === statusMessage.serviceId)?.ref;

      if (!serviceRef) return;

      const newWorkflow = cloneDeep(application!.workflows[0]);
      const serviceIndex = newWorkflow.procedure.findIndex(el => el.id === serviceRef);

      if (serviceIndex < 0) return;

      if (!newWorkflow.procedure[serviceIndex].data.statusModel) newWorkflow.procedure[serviceIndex].data.statusModel = {};
      newWorkflow.procedure[serviceIndex].data.statusModel.status = statusMessage.status;
      setApplication(app => ({
        ...app!,
        workflows: [newWorkflow],
      }));
      const graph = translateGraph(newWorkflow.procedure);
      setNodes(graph.nodes);
      setEdges(graph.edges);
    }
    // eslint-disable-next-line
  }, [application]);

  // TODO improve asset type
  const retrieveNewAssetFile = useCallback((asset: any) => {
    const body = { path: asset.path, type: asset.messageType };

    Applications.getApplicationAssetFilesByDetails(+id!, body)
      .then(
        ({ data }) => {
          setAssetFiles(currentNotifications => {
            const newNotifications = cloneDeep(currentNotifications!);
            newNotifications.unshift({ ...asset, ...data });
            return newNotifications;
          });
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-asset-error', message, `Asset Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [id, showToast]);

  useEffect(() => {
    if (assetFiles) {
      EventEmitter.subscribe(['BDA_APP_ASSET_CREATED', 'BDA_APP_STATUS_CHANGE'], (newNotification: AppNotification) => {
        if (+newNotification.details.bdaId === +id!) {
          if (newNotification.type === "BDA_APP_STATUS_CHANGE") onStatusNotification(newNotification.details);
          else if (newNotification.details.executionId === selectedExecution) {
            if (newNotification.details.messageType !== "log") retrieveNewAssetFile(newNotification.details);
            else {
              setAssetFiles(currentNotifications => {
                const newNotifications = cloneDeep(currentNotifications!);
                newNotifications.unshift(newNotification.details);
                return newNotifications;
              });
            }
          }
        }
      });
      return () => EventEmitter.unsubscribe(['BDA_APP_ASSET_CREATED', 'BDA_APP_STATUS_CHANGE']);
    }
  }, [assetFiles, id, selectedExecution, onStatusNotification, retrieveNewAssetFile]);

  useEffect(() => {
    if (selectedExecution) {
      setAssetFiles(undefined);
      initAssetFiles();
    }
    // eslint-disable-next-line
  }, [selectedExecution]);

  const getApplication = () => {
    Applications.getApplication(+id!)
      .then(
        ({ data: app }) => {
          const procedure = cloneDeep(app.workflows[0].procedure);
          const fixedGraph = procedure.map(node => {
            if (node.type === "batch" || node.type === "stream") {
              node.data.label = node.data.label || node.data.name || node.data.text;
              node.data.name = node.data.name || node.data.text;
            }
            return node;
          });
          app.workflows[0].procedure = fixProcedure(fixedGraph, app.workflows[0].services);
          setApplication(app);
          const graph = translateGraph(app.workflows[0].procedure);
          setInitialGraph(graph);
          setNodes(graph.nodes);
          setEdges(graph.edges);
          setExecutionsOptions(app.workflows[0].runs?.sort((a, b) => isBefore(new Date(a.startDate), new Date(b.startDate)) ? 1 : -1).map(run => ({ label: run.startDate ? formatDate(run.startDate) : "", value: run.k8sRunId })) || []);
          setSelectedExecution(app.workflows[0].runs?.[0]?.k8sRunId);
          if (!app.workflows[0].runs || app.workflows[0].runs.length === 0) setAssetFiles([]);
        },
        () => {
          showToast('application-error', 'Could not get application.', 'Application Error', 'danger');
          setError(true);
        }
      );
  }

  const initAssetFiles = () => {
    Applications.getApplicationAssetFiles(+id!, selectedExecution!)
      .then(
        ({ data }) => setAssetFiles(data),
        (err) => {
          setAssetFiles([]);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-notifications-error', message, `Notifications Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const reload = () => {
    setApplication(undefined);
    getApplication();
  }

  const showApplicationRuns = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    handleElementDetail({ type: "runs" });
  }
  const handleVersionsClose = () => setShowVersions(false);
  const handleNotificationsClose = () => setShowNotifications(false);
  const onShowVersions = () => setShowVersions(true);
  const onShowNotifications = () => setShowNotifications(true);

  // TODO improve element type
  const handleElementDetail = (element: any) => {
    setDataset(undefined);
    setService(undefined);
    setModel(undefined);
    setRuns(undefined);

    if (element.type === 'batch' || element.type === 'stream') {
      const service = application!.workflows[0].services.find(s => s.ref === element.id);
      setService(service);
    }
    else if (element.type === 'dataset') {
      const dataset = application!.datasets!.find(d => d.id === element.data.dataset.id);
      setDataset(dataset);
    }
    else if (element.type === "model") {
      const model = application!.models!.find(m => m.id === getIdFromUUID(element.id));
      setModel(model);
    }
    else if (element.type === "runs") {
      setRuns(application!.workflows![0].runs!);
    }
    setShowElementDetail(true);
  }

  const closeElementDetail = () => {
    setService(undefined);
    setModel(undefined);
    setDataset(undefined);
    setRuns(undefined);
    setShowElementDetail(false);
  }

  const changeAppVersion = (version: ApplicationVersion) => () => navigate(`/bda-applications/${version.bdaId}`, { replace: true });
  const navigateToApplicationEdit = () => navigate(`/bda-applications/${id}/edit`);
  const onDeleteApplication = () => setShowDeleteModal(true);
  const onExportApplication = () => {
    setShowExportModal(true);
    // if (application.workflows[0].mode === 'STREAM') setShowExportModal(true);
    // else downloadApplicationJSON();
  }
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setShowDeleteScheduleModal(false);
  }
  const handleExportClose = () => setShowExportModal(false);
  const handleScheduleClose = () => {
    setShowScheduleModal(false);
    setNewSchedule(new Schedule());
    setValidated(false);
  }
  const openScheduleModal = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    setShowScheduleModal(true);
  }
  const handleExportModeChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    const value = evt.target.value;
    setExportMode(value);
  }
  const handleExportOptionsChange = (field: keyof ExportOptions) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.checked || evt.target.value;
    setExportOptions({
      ...exportOptions,
      [field]: value,
    });
  }
  const handleScheduleFieldChange = (field: keyof Schedule, pure?: boolean) => (evt: any) => {
    const value = pure ? evt : evt.target.value;
    setNewSchedule({
      ...newSchedule,
      [field]: value,
    });
    if (field === "cronExpression") setCustomCron(evt);
  }
  const handleScheduleEdit = (index: number) => () => {
    const schedule = { ...application!.workflows[0].schedules![index] };
    setNewSchedule(schedule);
    setShowScheduleModal(true);
  }
  const openDeleteScheduleModal = (schedule: Schedule) => () => {
    setSchedule(schedule);
    setShowDeleteScheduleModal(true);
  }
  const handleDataModalClose = () => {
    setShowDataModal(false);
    setLogs(undefined);
    setPreview(undefined);
    setPreviewDataset(undefined);
    setEvaluationDataset(undefined);
  }
  const onShowLogs = () => {
    setShowDataModal(true);
    getLogs();
  }

  const handleCronError = (evt: any) => setCronError(evt?.description);
  const handleCustomCronChange = (evt: React.ChangeEvent<HTMLInputElement>) => setCustomCron(evt.target.value);
  const updateScheduleCron = () => {
    setNewSchedule({
      ...newSchedule,
      cronExpression: customCron!,
    });
  }

  const setDefaultVersion = (version: ApplicationVersion) => (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    showLoader();

    Applications.setDefaultVersion(version.bdaId)
      .then(
        () => {
          hideLoader();
          showToast('app-version-success', "Updated application default version successfully", "Default Version Updated", 'success');
          reload();
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-version-error', message, `Version Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const handleScheduleToggle = (index: number) => () => {
    const schedule = { ...application!.workflows[0].schedules![index] };
    const updatedSchedule = { ...schedule, suspend: !schedule.suspend };
    const promise = schedule.suspend
      ? Schedules.resumeSchedule(application!.id!, application!.workflows[0].id!, updatedSchedule)
      : Schedules.suspendSchedule(application!.id!, application!.workflows[0].id!, updatedSchedule);

    showLoader();

    promise.then(
      () => {
        hideLoader();
        reloadAppSchedules();
        showToast('schedule-toggle-success', `Schedule ${schedule.suspend ? "resumed" : "suspended"} successfully`, "Schedule Success", 'success');
      },
      (err) => {
        hideLoader();
        const message = err.response?.data?.message || err.message;
        const status = err.response?.status;
        showToast('schedule-toggle-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
      }
    )
  }

  const onShowPreview = () => {
    setPreview(undefined);
    setShowDataModal(true);
    setPreviewDataset(dataset);
    getPreview(dataset!);
  }

  const downloadLogs = () => getLogs(true);

  const getPreview = (selectedDataset: BdaDataset) => {
    const _previewDataset = selectedDataset || previewDataset;
    const connectionDetails = getConnectionDetails(_previewDataset.datasource!, undefined, _previewDataset.datasetFileType);
    const body = createQueryDetails(connectionDetails);

    VizClient.getDatasetPreview(body, connectionDetails.type)
      .then(
        ({ data: preview }) => setPreview(preview?.result?.data || []),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('dataset-error', message, `Dataset Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const reloadAppSchedules = () => {
    const newApp = cloneDeep(application!);
    set(newApp, 'workflows.0.schedules', null);
    setApplication(newApp);

    Schedules.getSchedules(application!.id!, application!.workflows[0].id!)
      .then(
        ({ data: schedules }) => {
          set(newApp, 'workflows.0.schedules', schedules);
          setApplication(newApp);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('dataset-error', message, `Dataset Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const deleteSchedule = () => {
    showLoader();

    Schedules.deleteSchedule(application!.id!, application!.workflows[0].id!, schedule!.id!)
      .then(
        () => {
          hideLoader();
          showToast("schedule-delete-success", `Application Schedule deleted successfully`, "Schedule Success", "success")
          handleDeleteClose();
          reloadAppSchedules()
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('schedules-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const handleScheduleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();
    setValidated(true);

    if (form.checkValidity() === true) {
      const promise = newSchedule.id
        ? Schedules.updateSchedule(application!.id!, application!.workflows[0].id!, newSchedule)
        : Schedules.createSchedule(application!.id!, application!.workflows[0].id!, newSchedule);

      showLoader();

      promise.then(
        () => {
          hideLoader();
          showToast("schedule-create-success", `Application Schedule ${newSchedule.id ? 'updated' : 'created'} successfully`, "Schedule Success", "success")
          handleScheduleClose();
          reloadAppSchedules()
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('schedules-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
    }
  }

  const getLogs = (download?: boolean) => {
    if (download) showLoader();

    const appId = application!.id!;
    const workflowId = application!.workflows[0].id!;
    const serviceId = service!.id!;

    const params = new URLSearchParams();
    if (download) params.set('download', `${true}`);
    else params.set('tail_lines', `${200}`);

    const promise = download
      ? K8sClient.downloadServiceLogs(appId, workflowId, serviceId, params)
      : K8sClient.getServiceLogs(appId, workflowId, serviceId, params);

    promise
      .then(
        ({ data: logs }) => {
          if (download) {
            hideLoader();
            const fileContent = new Blob([logs], { type: 'application/zip' });
            showToast('get-logs-success', 'Service logs ready to download.', 'Logs Success', 'success');
            FileSaver.saveAs(fileContent, `${application!.name} - ${service!.name} Logs.zip`);
          }
          else setLogs(logs);
        },
        () => {
          if (download) hideLoader();
          else setLogsError(true);
          showToast('get-logs-error', 'Could not get service logs.', 'Logs Error', 'danger');
        }
      )
  }

  const toggleApplication = () => application!.status === "RUNNING" || application!.status === "PARTIAL" || application!.status === "STARTING" ? stopApplication() : runApplication();

  const runApplication = () => {
    showLoader();

    // const settings = {
    //   organizationId: application.owner.organization.id,
    //   organizationName: application.owner.organization.name,
    //   ownerId: application.owner.id,
    //   ownerName: application.owner.name,
    //   workflow: application.workflows[0],
    // };
    const workflowId = application!.workflows[0].id!;

    Applications.runApplication(application!.id!, workflowId)
      .then(
        (_) => {
          showToast('bda-run-success', 'Application started successfully.', 'Success', 'success');
          hideLoader();
        },
        (err) => {
          showToast('bda-run-error', 'Could not execute application.', 'Application Error', 'danger');
          hideLoader();
        }
      );
  }

  const stopApplication = () => {
    showLoader();

    // const settings = {
    //   organizationId: application.owner.organization.id,
    //   organizationName: application.owner.organization.name,
    //   ownerId: application.owner.id,
    //   ownerName: application.owner.name,
    //   workflow: application.workflows[0],
    // };
    const workflowId = application!.workflows[0].id!;

    Applications.stopApplication(application!.id!, workflowId)
      .then(
        (_) => {
          showToast('bda-stop-success', 'Application stopped successfully.', 'Success', 'success');
          hideLoader();
        },
        (err) => {
          showToast('bda-stop-error', 'Could not stop application.', 'Application Error', 'danger');
          hideLoader();
        }
      );
  }

  const downloadApplicationJSON = () => {
    const applicationString = JSON.stringify(application);
    const blob = new Blob([applicationString], { type: 'application/json' });
    FileSaver.saveAs(blob, application!.name);
  }

  const exportApplication = () => {
    if (exportMode === 'cluster') downloadApplicationJSON();

    else {
      showLoader();

      const body = { ...exportOptions };
      body.bda = application;

      if (application!.workflows[0].mode === "BATCH") delete body.kafka;

      Applications.exportApplication(body)
        .then(
          ({ data: bundle }) => {
            hideLoader();
            const blob = new Blob([bundle], { type: exportOptions.rar ? 'application/tar' : 'application/zip' });
            FileSaver.saveAs(blob, `${application!.name}${exportOptions.rar ? '.tar' : '.zip'}`);
          },
          () => {
            hideLoader();
            showToast('bda-export-error', 'Could not export application.', 'Application Error', 'danger');
          }
        );
    }
  }

  const deleteApplication = () => {
    showLoader();

    Applications.deleteApplication(application!.id!)
      .then(
        () => {
          showToast('bda-delete-success', 'Application deleted successfully.', 'Success', 'success');
          hideLoader();
          handleDeleteClose();
          navigate('/bda-applications');
        },
        () => {
          showToast('bda-delete-error', 'Could not delete application.', 'Application Error', 'danger');
          hideLoader();
        }
      );
  };

  const openDatasetPreview = (dataset: BdaDataset) => () => {
    setShowDataModal(true);
    setPreviewDataset(dataset);
    getPreview(dataset);
  }

  const openEvaluation = (dataset: BdaDataset) => () => {
    setEvaluationDataset(dataset);
    setShowDataModal(true);
  }

  const handleRunSelection = (run: Execution) => () => {
    setSelectedRun(run);
    // update workflow graph
    const newGraph = translateGraph(application!.workflows[0].procedure);
    run.servicesStatus.forEach(s => {
      const serviceIndex = newGraph.nodes.findIndex(el => el.id === s.serviceRef);

      if (serviceIndex < 0) return;

      if (!newGraph.nodes[serviceIndex].data.statusModel) newGraph.nodes[serviceIndex].data.statusModel = {};
      newGraph.nodes[serviceIndex].data.statusModel.status = s.serviceStatus;
    });
    setNodes(newGraph.nodes);
    setEdges(newGraph.edges);
    // setCurrentGraph(newGraph);
  }

  const handleRunClose = () => {
    setSelectedRun(undefined);
    // setCurrentGraph(application.workflows[0].procedure);
    const graph = translateGraph(application!.workflows[0].procedure);
    setNodes(graph.nodes);
    setEdges(graph.edges);
  }

  const downloadModel = (model: BdaModel) => () => {
    Models.downloadModel(model.id)
      .then(
        ({ data: modelToDownload }) => {
          const blob = new Blob([modelToDownload], { type: 'application/zip' });
          FileSaver.saveAs(blob, `${model.name}.zip`);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('models-error', message, `Model Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const downloadFile = useCallback((file: AssetFile) => () => {
    showLoader();
    const body = { type: file.messageType, path: file.path };

    Applications.getApplicationAssetFilesByDetails(+id!, body)
      .then(
        ({ data }) => {
          hideLoader();
          const fileContent = typeof data === 'object' ? atob(data.content) : data;
          FileSaver.saveAs(new Blob([fileContent]), `${file.name}.${file.extension}`);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('file-download-error', message, `Download Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [id, showLoader, hideLoader, showToast]);

  const renderDatasetPreview = () => {
    if (!preview) return (
      <div className="d-flex justify-content-center py-3">
        <AppLoader size={250} />
      </div>
    )

    return preview.length
      ? (
        <div className="table-wrapper">
          <Table bordered>
            <thead>
              <tr>
                {Object.keys(preview[0]).map(key => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {preview.map((row, i) => (
                <tr key={i}>
                  {Object.keys(row).map((col, j) => (
                    <td key={j}>{row[col]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
      : (
        <Alert className="py-2 mb-0">
          <FontAwesomeIcon icon={solid('info-circle')} />
          <span className="ms-2">Dataset is empty</span>
        </Alert>
      )
  }

  const renderServiceLogs = () => {
    if (logsError) return (
      <Alert variant="danger">
        <FontAwesomeIcon icon={solid('exclamation-triangle')} />
        <span className="ms-2">An error occured, please try again later.</span>
      </Alert>
    );

    if (!logs) return (
      <div className="d-flex justify-content-center py-5">
        <AppLoader size={300} />
      </div>
    );

    const text = logs.messages[0] as string;
    return (
      <p className="service-logs">
        {text.split("\n").map(line => (
          <div>
            <code>{line}</code>
          </div>
        ))}
      </p>
    );
  }

  const renderAssetFiles = () => {
    return (
      <div>
        <div className="d-flex align-items-center mb-3">
          <Col md={4}>
            <Form.Label>Execution</Form.Label>
          </Col>
          <Select placeholder="Application Execution" className="w-100" value={selectedExecution} onChange={setSelectedExecution} options={executionsOptions} />
        </div>

        {!assetFiles && (
          <div className="d-flex justify-content-center py-5">
            <TailSpin
              height={100}
              width={100}
              color="#677ab1"
              radius="1"
            />
          </div>
        )}

        {assetFiles?.length === 0 && (
          <Alert variant="info" className="m-0 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">No media found for this application.</span>
          </Alert>
        )}

        {
          assetFiles
            ?.sort((a, b) => isAfter(new Date(a.modified), new Date(b.modified)) ? -1 : 1)
            .map(file => <AssetFileItem key={file.uuid} file={file} onDownload={downloadFile(file)} />)
        }
      </div>
    )
  }

  const renderApplicationMedia = () => {
    return (
      <>
        <button className="versions-toggle" onClick={onShowNotifications}>
          <FontAwesomeIcon icon={regular('images')} />
          <span className="ms-2">Application Media</span>
        </button>

        <Offcanvas show={showNotifications} onHide={handleNotificationsClose} placement="end">
          <Offcanvas.Header className="border-bottom" closeButton>
            <h6 className="m-0">Application Media</h6>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-2">
            {renderAssetFiles()}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }

  const renderVersions = () => {
    return (
      <>
        <button className="ms-2 versions-toggle" onClick={onShowVersions}>
          <FontAwesomeIcon icon={solid('tag')} />
          <span className="ms-2">Version {application!.version}</span>

          <FontAwesomeIcon className="ms-3" icon={solid('chevron-down')} />
        </button>

        <Offcanvas show={showVersions} onHide={handleVersionsClose} placement="end">
          <Offcanvas.Header className="border-bottom" closeButton>
            <h6 className="m-0">Application Versions</h6>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {application!.versions
              ?.sort((a, b) => b.version - a.version)
              .map(version => (
                <div key={version.version} className={classNames("version-item", { selected: version.bdaId === +id! })} onClick={changeAppVersion(version)}>
                  <div className="pe-3">
                    <FontAwesomeIcon icon={solid('tag')} />
                  </div>
                  <Col>
                    <h6 className="mb-0">{version.version}</h6>
                    <span className="text-muted">{formatDate(version.createdDate)}</span>
                  </Col>
                  <IconButton onClick={setDefaultVersion(version)} tooltip="Default version">
                    <FontAwesomeIcon className={classNames({ "text-warning": version.defaultVersion })} icon={version.defaultVersion ? solid('star') : regular('star')} />
                  </IconButton>
                </div>
              ))}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }

  const renderApplicationRuns = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <h6 className="mb-0 me-2">Application Executions</h6>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body p-0">
          {runs!.length === 0 && (
            <Alert className="py-2 m-2">
              <FontAwesomeIcon icon={solid('info-circle')} />
              <span className="ms-2">No executions found for this application.</span>
            </Alert>
          )}

          {runs!.length > 0 && (
            <ListGroup>
              {runs!
                .sort((a, b) => isBefore(a.startDate ? new Date(a.startDate) : new Date(a.dateOfLastStatus), b.startDate ? new Date(b.startDate) : new Date(b.dateOfLastStatus)) ? 1 : -1)
                .map(run => (
                  <ListGroup.Item onClick={handleRunSelection(run)} className={classNames("run-item", { selected: selectedRun?.id === run.id })} key={run.id}>
                    <FontAwesomeIcon size="lg" icon={selectedRun?.id === run.id ? solid('caret-left') : run.runType === "SCHEDULED" ? regular('clock') : solid('hand-pointer')} fixedWidth />

                    <div className="ps-3">
                      {run.startDate && <h6 className="mb-1">{formatDate(run.startDate)}</h6>}
                      {getStatusBadge(run.currentStatus)}
                    </div>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          )}
        </div>

        {/* <div className="element-detail-footer">
          <Button size="sm" variant="light" className="border" onClick={onShowPreview}>
            <FontAwesomeIcon icon={solid('table')} />
            <span className="ms-2">Show Preview</span>
          </Button>
        </div> */}
      </div>
    )
  }

  const renderModelDetail = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/models/${model!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{model!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <div className="mb-2">
            <Form.Label>Algorithm</Form.Label>
            <code className="d-block">{model!.algorithmName}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Location</Form.Label>
            <code className="d-block">{model!.location}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Input Columns</Form.Label>
            <code className="d-block">{model!.inputs}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Dataset</Form.Label>
            <code className="d-block">{model!.trainingDataset.name}</code>
          </div>

          <h6>Properties</h6>
          <Table className="table-schema" bordered>
            <thead className="bg-light">
              <tr>
                <th>Name</th>
                <th className="text-center" style={{ width: "40%" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {model!.properties?.map((prop, index) => {
                const key = Object.keys(prop)[0];
                return (
                  <tr key={index}>
                    <td>{key}</td>
                    <td className="text-center">
                      <small className="text-muted text-uppercase">{prop[key]}</small>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }

  const renderDatasetDetail = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/datasets/${dataset!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{dataset!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <div className="mb-2">
            <Form.Label>Datasource</Form.Label>
            <code className="d-block">{dataset!.datasource!.name}</code>
          </div>

          <div className="mb-2">
            <Form.Label>Type</Form.Label>
            <code className="d-block">{dataset!.datasetFileType!.type}</code>
          </div>

          {dataset!.datasetFileType!.type === "table" &&
            (
              <>
                <h6>Dataset Columns</h6>
                <Table className="table-schema" bordered>
                  <thead className="bg-light">
                    <tr>
                      <th>Name</th>
                      <th className="text-center" style={{ width: "40%" }}>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataset!.datasetFileType?.columns?.map((col, index) => (
                      <tr key={col.name}>
                        <td>{col.name}</td>
                        <td className="text-center">
                          <small className="text-muted text-uppercase">{col.type}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
        </div>

        <div className="element-detail-footer">
          <Button size="sm" variant="light" className="border" onClick={onShowPreview}>
            <FontAwesomeIcon icon={solid('table')} />
            <span className="ms-2">Show Preview</span>
          </Button>
        </div>
      </div>
    )
  }

  const renderServiceDetail = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/services/${service!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{service!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <Form.Label>Label</Form.Label>
            <div>{service!.label || service!.name}</div>
          </div>

          <div className="d-flex align-items-center justify-content-between mb-2">
            <Form.Label>Version</Form.Label>
            <Badge bg="light" className="border text-dark">
              <FontAwesomeIcon icon={solid('tag')} />
              <span className="ms-2">{service!.version}</span>
            </Badge>
          </div>

          {service!.statusModel && (
            <>
              <div className="d-flex mb-2 justify-content-between">
                <Form.Label>Status</Form.Label>
                <div className="px-0 text-end">{getStatusBadge(service!.statusModel.status)}</div>
              </div>
              {service!.statusModel.status === "COMPLETED" && (
                <div className="d-flex mb-2 justify-content-between">
                  <Form.Label>Execution Time</Form.Label>
                  <Badge bg="light" className="border text-dark">
                    <FontAwesomeIcon icon={regular('clock')} />
                    <span className="ms-1">{getExecutionTime(service!.statusModel)}</span>
                  </Badge>
                </div>
              )}
            </>
          )}

          <div className="mb-2">
            <Form.Label>Owner</Form.Label>
            <UserItem className="w-50 sm border p-1 rounded" user={service!.owner} organization={service!.organization} />
          </div>

          {serviceIsExposable && (
            <Alert variant="info" className="my-3 py-2 d-flex align-items-center">
              <FontAwesomeIcon icon={solid('info-circle')} />
              <span className="ms-2 me-auto">Service can be reached on the web.</span>
              <Tooltip title={service!.statusModel?.status !== ExecutionStatus.RUNNING ? "Available as soon as the service starts running" : null}>
                <span id="disabled-button-wrapper">
                  <Button disabled={service!.statusModel?.status !== ExecutionStatus.RUNNING} size="sm" variant="success" href={`${window.__env.EXPOSED_SERVICES_URL}/${id}/${service!.id}/`} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={solid('external-link')} />
                    <span className="ms-2">Visit now</span>
                  </Button>
                </span>
              </Tooltip>
            </Alert>
          )}

          {service!.properties
            .filter(prop => !!prop.value)
            .map(prop => (
              <div className="mb-2" key={prop.id}>
                <Form.Label>{prop.key}</Form.Label>
                {prop.extra?.mode === 'streaming'
                  ? renderTopicLink(prop.value)
                  : <code className="d-block">{prop.value}</code>
                }
              </div>
            ))}
        </div>

        <div className="element-detail-footer">
          <Button size="sm" variant="light" className="border" onClick={onShowLogs}>
            <FontAwesomeIcon icon={solid('align-left')} />
            <span className="ms-2">Show Logs</span>
          </Button>
        </div>
      </div>
    )
  }

  const renderDatasetBedge = (dataset: BdaDataset) => {
    var text, background;

    if (!dataset.createdBy) {
      text = "IN";
      background = "success";
    }
    else if (dataset.type === "EVALUATION" || dataset.type === "STATISTICS") {
      text = dataset.type;
      background = dataset.type === "STATISTICS" ? "primary" : "pink";
    }
    else if (dataset.createdByBdaId === +id!) {
      text = "OUT";
      background = "danger";
    }

    return <Badge bg={background}>{text}</Badge>
  }

  const renderModelBedge = (model: BdaModel) => {
    const text = model.createdByBdaId === +id! ? "OUT" : "IN";
    const background = model.createdByBdaId === +id! ? "danger" : "success";

    return <Badge bg={background}>{text}</Badge>
  }

  const renderApplicationGroups = () => {
    return (
      <>
        <Collapse ghost>
          <Collapse.Panel
            className="no-padding mb-2"
            showArrow={false}
            header={
              <>
                <FontAwesomeIcon icon={groupsIcons.datasets} fixedWidth />
                <span className="ms-2">Datasets</span>
              </>
            }
            key="datasets"
          >
            {application!.datasets?.length === 0 && (
              <Alert className="py-2">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2">No datasets found for this application.</span>
              </Alert>
            )}

            {application!.datasets && application!.datasets.length > 0 && (
              <ListGroup>
                {application!.datasets?.map(dataset => (
                  <ListGroupItem key={dataset.id} className="d-flex align-items-center">
                    <div className="pe-3">{renderDatasetBedge(dataset)}</div>

                    <Col>
                      <h6 className="mb-0">
                        <Link to={`/datasets/${dataset.id}`} target="_blank" rel="noopener noreferrer">{dataset.name}</Link>
                      </h6>
                      <small className="text-muted">{formatDate(dataset.createDateTime!)}</small>
                    </Col>

                    {dataset.created && dataset.type !== 'STATISTICS' && dataset.type !== 'EVALUATION' && (
                      <IconButton onClick={openDatasetPreview(dataset)} tooltip="Preview">
                        <FontAwesomeIcon icon={solid('eye')} />
                      </IconButton>
                    )}
                    {dataset.created && dataset.type === 'EVALUATION' && (
                      <IconButton onClick={openEvaluation(dataset)} tooltip="Evaluation">
                        <FontAwesomeIcon icon={solid('chart-line')} />
                      </IconButton>
                    )}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </Collapse.Panel>

          <Collapse.Panel
            className="no-padding mb-2"
            showArrow={false}
            header={
              <>
                <FontAwesomeIcon icon={groupsIcons.models} fixedWidth />
                <span className="ms-2">Models</span>
              </>
            }
            key="models"
          >
            {application!.models?.length === 0 && (
              <Alert className="py-2">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2">No models found for this application.</span>
              </Alert>
            )}

            {application!.models && application!.models.length > 0 && (
              <ListGroup>
                {application!.models.map(model => (
                  <ListGroupItem key={model.id} className="d-flex align-items-center">
                    <div className="pe-3">{renderModelBedge(model)}</div>

                    <Col>
                      <h6 className="mb-0">
                        <Link to={`/models/${model.id}`} target="_blank" rel="noopener noreferrer">{model.name}</Link>
                      </h6>
                      <Badge bg="none" className="border text-muted me-2" pill>
                        <FontAwesomeIcon icon={solid('cubes')} />
                        <span className="ms-2">Created by service: {model.algorithmName}</span>
                      </Badge>
                      <small className="text-muted">{formatDate(model.createDateTime)}</small>
                    </Col>

                    {model.created && (
                      <IconButton onClick={downloadModel(model)} tooltip="Download">
                        <FontAwesomeIcon icon={solid('download')} />
                      </IconButton>
                    )}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </Collapse.Panel>

          <Collapse.Panel
            header={
              <>
                <FontAwesomeIcon icon={groupsIcons.schedules} fixedWidth />
                <span className="ms-2">Schedules</span>
              </>
            }
            key="schedules"
            className="no-padding mb-2"
            showArrow={false}
            extra={
              <button className="add-schedule-btn" onClick={openScheduleModal}>
                <FontAwesomeIcon icon={solid('plus')} />
                <span className="ms-2">Add Schedule</span>
              </button>
            }>
            {!application!.workflows[0].schedules && (
              <div className="d-flex justify-content-center p-3">
                <TailSpin
                  height={50}
                  width={50}
                  color="#677ab1"
                  radius="1"
                />
              </div>
            )}

            {application!.workflows[0].schedules?.length === 0 && (
              <Alert className="py-2">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2">No schedules found for this application.</span>
              </Alert>
            )}

            {application!.workflows[0].schedules && application!.workflows[0].schedules.length > 0 && (
              <ListGroup>
                {application!.workflows[0].schedules.map((schedule, index) => (
                  <ListGroupItem className="d-flex align-items-center" key={schedule.id}>
                    <div className="pe-3">
                      <FontAwesomeIcon className={classNames("schedule-icon", { active: !schedule.suspend })} size="lg" icon={regular('clock')} />
                    </div>

                    <Col>
                      <h6 className="mb-0">{schedule.name}</h6>
                      <span className="text-muted">{schedule.cronExpression}</span>
                    </Col>

                    <Col md={2} className="text-end">
                      <IconButton onClick={handleScheduleToggle(index)} tooltip="Toggle Schedule">
                        <FontAwesomeIcon className={schedule.suspend ? 'text-success' : 'text-warning'} icon={schedule.suspend ? solid('play') : solid('pause')} />
                      </IconButton>
                      <IconButton className="ms-2" onClick={handleScheduleEdit(index)} tooltip="Edit">
                        <FontAwesomeIcon icon={solid('pen')} />
                      </IconButton>
                      <IconButton className="ms-2 text-danger" onClick={openDeleteScheduleModal(schedule)} tooltip="Delete">
                        <FontAwesomeIcon icon={solid('trash')} />
                      </IconButton>
                    </Col>
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </Collapse.Panel>
        </Collapse>
      </>
    )
  }

  const renderAsyncContent = () => {
    if (error) return (
      <Alert variant="danger">
        <FontAwesomeIcon icon={solid('exclamation-triangle')} />
        <span className="ms-2">An error occured during application retrieve. Try again later.</span>
      </Alert>
    );

    if (!application) return (
      <div className="d-flex justify-content-center py-5">
        <AppLoader size={300} />
      </div>
    );

    const isStreaming = application.workflows[0].mode === 'STREAM';
    const modeClass = application.workflows[0].mode.toLowerCase();
    const modeIcon = application.workflows[0].mode === 'BATCH' ? solid('cog') : solid('align-left');

    return (
      <>
        <div className="d-flex align-items-center mb-3">
          <Col>
            <Breadcrumb>
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/bda-applications' }}>Applications</Breadcrumb.Item>
              <Breadcrumb.Item active>{application.name}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {renderApplicationMedia()}
          {application!.versions && application!.versions.length > 0 && renderVersions()}
        </div>


        <Card className="item-detail-group main bg-application">
          <FontAwesomeIcon className="item-icon" icon={solid('laptop-code')} />

          <div className="px-2 pt-2">
            <Row className="gx-0 justify-content-between">
              <Badge bg="none" className={classNames('application-mode w-auto shadow', modeClass)} pill={true}>
                <FontAwesomeIcon icon={modeIcon} />
                <span className="ms-2">{application.workflows[0].mode}</span>
              </Badge>

              <Badge className="w-auto shadow">
                {application.accessLevel}
              </Badge>
            </Row>

            <div className="p-2">
              <Row className="gx-0 align-items-center">
                <Col className="pe-3">
                  <h3 className="mb-0">{application.name}</h3>
                  <p className="mb-4">{application.description}</p>
                </Col>

                <div className="w-auto">
                  {application.mlFlowUrl && (
                    <a href={application.mlFlowUrl} target="_blank" rel="noopener noreferrer" className="me-3">
                      <Tooltip title="Experiments">
                        <button className="circle-button p-4">
                          <FontAwesomeIcon icon={solid('flask-vial')} />
                        </button>
                      </Tooltip>
                    </a>
                  )}
                  <Tooltip title={application.status === "RUNNING" || application.status === "PARTIAL" || application.status === "STARTING" ? "Pause" : "Run"}>
                    <button className="circle-button p-4" onClick={toggleApplication} disabled={application.status === "STARTING"}>
                      <FontAwesomeIcon icon={application.status === "RUNNING" || application.status === "PARTIAL" || application.status === "STARTING" ? solid('pause') : solid('play')} />
                    </button>
                  </Tooltip>
                  <Tooltip title="Export">
                    <button className="circle-button p-4 ms-3" onClick={onExportApplication}>
                      <FontAwesomeIcon icon={solid('share-square')} />
                    </button>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <button className="circle-button p-4 ms-3" onClick={navigateToApplicationEdit}>
                      <FontAwesomeIcon icon={solid('pen')} />
                    </button>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <button className="circle-button p-4 ms-3" onClick={onDeleteApplication}>
                      <FontAwesomeIcon icon={solid('trash')} />
                    </button>
                  </Tooltip>
                </div>
              </Row>
            </div>

            <Row className="gx-0 justify-content-between">
              <Col xs="auto">
                <div className="bg-highlight">
                  <UserItem className="negative" user={application.owner} organization={application.organization} />
                </div>
              </Col>

              <div className="d-flex flex-wrap">
                {
                  application.tags.map((tag, index) => <Badge key={index} className="m-1" pill={true}>{tag}</Badge>)
                }
              </div>
            </Row>

            <div className="item-dates">
              <div className="d-inline-block">
                <b>Created:</b>
                <span className="ms-1">{formatDate(application!.createDateTime!)}</span>
              </div>
              <div className="d-inline-block ms-2">
                <b>Last Update:</b>
                <span className="ms-1">{formatDate(application!.updateDateTime!)}</span>
              </div>
            </div>
          </div>

          <Card.Footer className={`application-status mt-2 detail-status ${application.status || 'READY'}`}>
            <span>{application.status || "READY"}</span>
          </Card.Footer>
        </Card>

        <Collapse className="mb-2" ghost defaultActiveKey="workflow">
          <Collapse.Panel
            header={
              <>
                <FontAwesomeIcon icon={solid('diagram-project')} fixedWidth />
                <span className="ms-2">Workflow</span>
              </>
            }
            key="workflow"
            className="p-0"
            showArrow={false}
            extra={
              <button className="add-schedule-btn" onClick={showApplicationRuns}>
                <FontAwesomeIcon icon={solid('history')} />
                <span className="ms-2">Executions</span>
              </button>
            }>
            <div className="application-workflow">
              <Col className="workflow-col position-relative">
                {selectedRun && (
                  <div className="run-info">
                    <FontAwesomeIcon size="lg" icon={selectedRun.runType === "SCHEDULED" ? regular('clock') : solid('hand-pointer')} fixedWidth />

                    <div className="ps-3">
                      <h6 className="mb-1">Execution: {selectedRun.startDate && formatDate(selectedRun.startDate)}</h6>
                      {getStatusBadge(selectedRun.currentStatus)}
                    </div>

                    <IconButton className="ms-3" onClick={handleRunClose}>
                      <FontAwesomeIcon size="lg" icon={solid('times')} />
                    </IconButton>
                  </div>
                )}
                <DesignerComponent
                  darkBackground={selectedRun !== undefined}
                  readOnly={true}
                  onElementSelected={handleElementDetail}
                  initialNodes={initialGraph?.nodes}
                  initialEdges={initialGraph?.edges}
                />
              </Col>

              <Col className={classNames('service-col', { open: showElementDetail })}>
                {service && renderServiceDetail()}
                {dataset && renderDatasetDetail()}
                {model && renderModelDetail()}
                {runs && renderApplicationRuns()}
              </Col>
            </div>
          </Collapse.Panel>
        </Collapse>

        {!isStreaming && renderApplicationGroups()}
      </>
    );
  }

  return (
    <Container className="mt-3 application-detail">
      <Helmet>
        <title>Application {id} Detail</title>
      </Helmet>

      {renderAsyncContent()}

      <br />

      <Modal show={showDeleteModal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete application <b>{application && application.name}</b>?</p>

          <Alert className="p-2" variant="warning">
            <FontAwesomeIcon icon={solid('exclamation-triangle')} />
            <span className="ms-2">Remember, this operation cannot be undone.</span>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" className="border" onClick={handleDeleteClose}>
            Close
          </Button>
          <Button variant="danger" size="sm" onClick={deleteApplication}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteScheduleModal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Application Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete schedule <b>{schedule && schedule.name}</b>?</p>

          <Alert className="p-2" variant="warning">
            <FontAwesomeIcon icon={solid('exclamation-triangle')} />
            <span className="ms-2">Remember, this operation cannot be undone.</span>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" className="border" onClick={handleDeleteClose}>
            Close
          </Button>
          <Button variant="danger" size="sm" onClick={deleteSchedule}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showScheduleModal} onHide={handleScheduleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{newSchedule?.id ? "Edit" : "Create"} Application Schedule</Modal.Title>
        </Modal.Header>
        {newSchedule && (
          <Form noValidate validated={validated} onSubmit={handleScheduleSubmit}>
            <Modal.Body>
              <Form.Group controlId="schedule-name" className="mb-3">
                <Form.Label>Schedule Name</Form.Label>
                <Form.Control size="sm" placeholder="Schedule name" value={newSchedule.name} onChange={handleScheduleFieldChange('name')} required />
                <Form.Control.Feedback type="invalid">Schedule Name is required.</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="schedule-cron-exepression" className="mb-3">
                <Form.Label className="mb-2">Cron Expression</Form.Label>
                <Cron value={newSchedule.cronExpression} clearButtonAction="empty" clearButtonProps={{ className: "bg-primary" }} setValue={handleScheduleFieldChange('cronExpression', true)} onError={handleCronError} />
                <h6 className="text-center text-muted">OR</h6>
                <Form.Control size="sm" value={customCron} onChange={handleCustomCronChange} onBlur={updateScheduleCron} placeholder="Manual cron expression" />
                {cronError && <Form.Control.Feedback type="invalid" className="d-block">{cronError}</Form.Control.Feedback>}
                <Form.Text>You can insert cron expression manually in the field above. To know more about the specs, please refer to <a href="https://crontab.guru/" target="_blank" rel="noopener noreferrer">crontab quick reference</a>.</Form.Text>
              </Form.Group>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" size="sm" type="button" className="border" onClick={handleScheduleClose}>Close</Button>
              <Button variant="success" size="sm" type="submit">Confirm</Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal>

      <Modal show={showExportModal} onHide={handleExportClose}>
        <Modal.Header closeButton>
          <Modal.Title>Export Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="export-mode" as={Row} className="gx-0 align-items-center">
            <Col md={6} lg={4}>
              <Form.Label>Export Mode</Form.Label>
            </Col>
            <Col md={6} lg={8}>
              <Form.Select size="sm" value={exportMode} onChange={handleExportModeChange}>
                <option value="cluster">Cluster</option>
                <option value="standalone">Standalone</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {exportMode === 'standalone' && (
            <>
              {application?.workflows[0].mode === "STREAM" && <Form.Check id="enable-kafka" type="checkbox" onChange={handleExportOptionsChange('kafka')} className="mb-2 mt-3" label="Enable Kafka" />}
              <Form.Check id="export-rar" type="checkbox" onChange={handleExportOptionsChange('rar')} disabled label="Export .rar" />
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="light" size="sm" className="border" onClick={handleExportClose}>Close</Button>
          <Button variant="success" size="sm" onClick={exportApplication}>
            <FontAwesomeIcon icon={solid('share-square')} />
            <span className="ms-2">Export</span>
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size={evaluationDataset ? "xl" : "lg"} show={showDataModal} onHide={handleDataModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {service && `${service.name} Logs`}
            {previewDataset && `${previewDataset.name} Preview`}
            {evaluationDataset && `${evaluationDataset.name}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {service && renderServiceLogs()}
          {previewDataset && renderDatasetPreview()}
          {evaluationDataset && <EvaluationRecap dataset={evaluationDataset} />}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {logs
            ? (
              <Button variant="light" className="border text-primary" size="sm" onClick={downloadLogs}>
                <FontAwesomeIcon icon={solid('download')} />
                <span className="ms-2">Download Log File</span>
              </Button>
            )
            : (
              <Button variant="light" size="sm" className="border" onClick={handleDataModalClose}>
                Close
              </Button>
            )}
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default function withProvider() {
  return (
    <ReactFlowProvider>
      <BdaApplicationDetail />
    </ReactFlowProvider>
  )
}